module.exports = __webpack_public_path__ + "img/samarabanner.d612c03d.png";